//Hide or show scroll animation
$(function() {
    var bodyHeight = $('body').height();
    var windowHeight = $(window).height();

    if (bodyHeight <= windowHeight) {
        $('.scroll-animation').hide();
    }
});
